import { render } from "./MessageCreate.vue?vue&type=template&id=55ee81e2"
import script from "./MessageCreate.vue?vue&type=script&lang=js"
export * from "./MessageCreate.vue?vue&type=script&lang=js"

import "./MessageCreate.vue?vue&type=style&index=0&id=55ee81e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__